import React from "react";
import styled from "styled-components";
import Header from "../header/Header";
import Footer from "../footer/Footer";
import OnePageHeader from "../header/OnePageHeader";

const OnePageLayout = ({ title, children }) => {
  return (
    <>
      <OnePageHeader title={title} />
      <Main>{children}</Main>
      {/* <Footer /> */}
    </>
  );
};

export default OnePageLayout;

const Main = styled.main``;
